'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ChatHeadingConfigPropType = require('ui-addon-conversations/chat-heading-config/prop-types/ChatHeadingConfigPropType');

var _ChatHeadingConfigPropType2 = _interopRequireDefault(_ChatHeadingConfigPropType);

var _AvatarSize = require('../../visitor-widget/constants/AvatarSize');

var _AvatarSize2 = _interopRequireDefault(_AvatarSize);

var _ChatHeadGroup = require('../ChatHeadGroup');

var _ChatHeadGroup2 = _interopRequireDefault(_ChatHeadGroup);

var _CustomChatHeading = require('../CustomChatHeading');

var _CustomChatHeading2 = _interopRequireDefault(_CustomChatHeading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChatHeadingAvatars = function (_React$PureComponent) {
  _inherits(ChatHeadingAvatars, _React$PureComponent);

  function ChatHeadingAvatars() {
    _classCallCheck(this, ChatHeadingAvatars);

    return _possibleConstructorReturn(this, (ChatHeadingAvatars.__proto__ || Object.getPrototypeOf(ChatHeadingAvatars)).apply(this, arguments));
  }

  _createClass(ChatHeadingAvatars, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          chatHeadingConfig = _props.chatHeadingConfig,
          chatHeadingResponders = _props.chatHeadingResponders,
          mobile = _props.mobile,
          showStatusIndicator = _props.showStatusIndicator;


      var size = mobile ? _AvatarSize2.default.SMALL : _AvatarSize2.default.MEDIUM;

      var AvatarComponent = chatHeadingResponders.size ? _ChatHeadGroup2.default : _CustomChatHeading2.default;

      return _react2.default.createElement(AvatarComponent, {
        size: size,
        mobile: mobile,
        responders: chatHeadingResponders,
        chatHeadingConfig: chatHeadingConfig,
        showStatusIndicator: showStatusIndicator
      });
    }
  }]);

  return ChatHeadingAvatars;
}(_react2.default.PureComponent);

ChatHeadingAvatars.propTypes = {
  chatHeadingConfig: _ChatHeadingConfigPropType2.default.isRequired,
  chatHeadingResponders: _react.PropTypes.instanceOf(_immutable.List).isRequired,
  mobile: _react.PropTypes.bool.isRequired,
  showStatusIndicator: _react.PropTypes.bool.isRequired
};

ChatHeadingAvatars.defaultProps = {
  mobile: false,
  showStatusIndicator: false
};

exports.default = ChatHeadingAvatars;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/visitor-widget/components/ChatHeadingAvatars.js
// module id = 512
// module chunks = 2 3